angular.module('bizmetryApp').service('ResourceService', [
  '$http', 'CONFIG',
  function ($http, CONFIG) {

    const BASE = CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-resource';

    function getAccountId() {
      try {
        const user = JSON.parse(sessionStorage.getItem('user'));
        return user && user.id ? user.id : null;
      } catch (e) {
        return null;
      }
    }

    function getBearer() {
      return (
        sessionStorage.getItem('access_token') ||
        sessionStorage.getItem('token') ||
        (JSON.parse(sessionStorage.getItem('user') || '{}').token) ||
        null
      );
    }

    function baseHeaders() {
      return { 'X-User-Account-Id': getAccountId() };
    }

    function authHeaders() {
      const h = baseHeaders();
      const bearer = getBearer();
      if (bearer) h['Authorization'] = bearer.startsWith('Bearer ') ? bearer : `Bearer ${bearer}`;
      return h;
    }

    // ======================
    // LIST BY PROFILE
    // GET /profile/{profileId}/resources
    // Soporta: page, size, search, sort, resourceType
    // ======================
    this.listResourcesByProfile = function (profileId, options = {}) {
      const params = {
        page: options.page !== undefined ? options.page : 0,
        size: options.size !== undefined ? options.size : 10
      };

      if (options.search)       params.search       = options.search;
      if (options.sort)         params.sort         = options.sort;
      if (options.resourceType) params.resourceType = options.resourceType;

      return $http.get(
        `${BASE}/profile/${profileId}/resources`,
        { headers: authHeaders(), params }
      );
    };

    this.exploreResources = function (profileId, options) {
      return $http.get(`${BASE}/profile/${profileId}/resources/explore`, {
        headers: authHeaders(), params: options
      });
    };

    // ======================
    // GET RESOURCE TYPES BY PROFILE
    // GET /profile/{profileId}/resources/types
    // Returns distinct resource types instantiated in this profile
    // ======================
    this.getResourceTypesByProfile = function (profileId) {
      return $http.get(
        `${BASE}/profile/${profileId}/resources/types`,
        { headers: authHeaders() }
      );
    };

    // ======================
    // GET ONE
    // GET /profile/{profileId}/resources/{resourceId}
    // ======================
    this.getResourceById = function (profileId, resourceId) {
      return $http.get(
        `${BASE}/profile/${profileId}/resources/${resourceId}`,
        { headers: authHeaders() }
      );
    };

    // ======================
    // CREATE
    // POST /profile/{profileId}/resources
    // ======================
    this.createResource = function (profileId, payload) {
      return $http.post(
        `${BASE}/profile/${profileId}/resources`,
        payload,
        { headers: authHeaders() }
      );
    };

    // ======================
    // PATCH
    // PATCH /profile/{profileId}/resources/{resourceId}
    // ======================
    this.patchResource = function (profileId, resourceId, payload) {
      return $http.patch(
        `${BASE}/profile/${profileId}/resources/${resourceId}`,
        payload,
        { headers: authHeaders() }
      );
    };

    // ======================
    // DELETE
    // DELETE /profile/{profileId}/resources/{resourceId}
    // ======================
    this.deleteResource = function (profileId, resourceId) {
      return $http.delete(
        `${BASE}/profile/${profileId}/resources/${resourceId}`,
        { headers: authHeaders() }
      );
    };

    // ======================
    // BULK DELETE BY IDs
    // DELETE /profile/{profileId}/resources/byIds
    // payload: { resources: ['uuid', 'uuid', ...] }
    // ======================
    this.bulkDeleteByIds = function (profileId, resourceIds) {
  const headers = authHeaders();
  headers['Content-Type'] = 'application/json';

  return $http({
    method: 'DELETE',
    url: `${BASE}/profile/${profileId}/resources/byIds`,
    data: { resources: resourceIds },
    headers: headers
  });
};

    // ======================
    // SOURCE RECORD (stored at import, no agent call)
    // GET /profile/{profileId}/resources/{resourceId}/environments/{environmentId}/source-record
    // ======================
    this.getSourceRecord = function (profileId, resourceId, environmentId) {
      return $http.get(
        `${BASE}/profile/${profileId}/resources/${resourceId}/environments/${environmentId}/source-record`,
        { headers: authHeaders() }
      );
    };

    // ======================
    // DELETE ALL OF A TYPE
    // DELETE /profile/{profileId}/resources/byType/{resourceTypeId}
    // One server-side DELETE for the whole type ("Delete All").
    // ======================
    this.deleteAllByType = function (profileId, resourceTypeId) {
      return $http.delete(
        `${BASE}/profile/${profileId}/resources/byType/${resourceTypeId}`,
        { headers: authHeaders() }
      );
    };

    // ======================
    // IMPORT RESOURCES
    // POST /profile/{profileId}/resources/import
    // ======================
    this.importResources = function (profileId, payload) {
      return $http.post(
        `${BASE}/profile/${profileId}/resources/import`,
        payload,
        { headers: authHeaders() }
      );
    };

    // ======================
    // GET RESOURCE PKS
    // GET /profile/{profileId}/resources/pks/environment/{environmentId}
    // ======================
    this.getResourcePKs = function (profileId, environmentId, resourceTypeId) {
      const params = {};
      if (resourceTypeId) params.resourceType = resourceTypeId;

      return $http.get(
        `${BASE}/profile/${profileId}/resources/pks/environment/${environmentId}`,
        { headers: authHeaders(), params }
      );
    };

  }
]);